import React, { useEffect, useState } from "react";
import axios from "axios";
import moment from "moment";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

// const PayableAgingReport = () => {
//     const [data, setData] = useState([]);
//     const [groupedData, setGroupedData] = useState({});
//     const [loading, setLoading] = useState(true);
//     const [vendors, setVendors] = useState([]);
//     const [selectedVendor, setSelectedVendor] = useState('');
//     const [dateRange, setDateRange] = useState('this_month');
//     const [summaryData, setSummaryData] = useState({
//         totalOutstanding: 0,
//         agingBuckets: {
//             '0-30': 0,
//             '31-60': 0,
//             '61-90': 0,
//             '90+': 0
//         }
//     });

//     const backendUrl = process.env.REACT_APP_BACKEND_URL;
//     const userInfo = JSON.parse(localStorage.getItem("user-info"));
//     const origin = localStorage.getItem("user-origin");
//     const token = userInfo?.token;

//     useEffect(() => {
//         fetchData();
//     }, [selectedVendor, dateRange]);

//     const fetchData = async () => {
//         try {
//             setLoading(true);
//             const params = selectedVendor ? { vendor_id: selectedVendor } : {};
//             const response = await axios.get(`${backendUrl}/api/payable`, {
//                 params,
//                 headers: {
//                     Authorization: `Bearer ${token}`,
//                     "Tenant-Origin": origin,
//                 },
//             });

//             const reportData = response.data.data || [];
//             const vendorList = response.data.vendors || {};

//             setData(reportData);
//             setVendors(Object.entries(vendorList).map(([id, name]) => ({ id, name })));
//             groupByVendor(reportData);
//             calculateSummary(reportData);
//         } catch (error) {
//             console.error("Error loading payable aging report:", error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     const calculateSummary = (items) => {
//         let total = 0;
//         const buckets = {
//             '0-30': 0,
//             '31-60': 0,
//             '61-90': 0,
//             '90+': 0
//         };

//         items.forEach(item => {
//             const amount = parseFloat(item.outstanding.replace(/,/g, ''));
//             total += amount;

//             if (item.aging_bucket === '0–30 Days') buckets['0-30'] += amount;
//             else if (item.aging_bucket === '31–60 Days') buckets['31-60'] += amount;
//             else if (item.aging_bucket === '61–90 Days') buckets['61-90'] += amount;
//             else buckets['90+'] += amount;
//         });

//         setSummaryData({
//             totalOutstanding: total,
//             agingBuckets: buckets
//         });
//     };

//     const groupByVendor = (items) => {
//         const grouped = {};
//         items.forEach((item) => {
//             if (!grouped[item.vendor_name]) grouped[item.vendor_name] = [];
//             grouped[item.vendor_name].push(item);
//         });
//         setGroupedData(grouped);
//     };

//     const exportToExcel = () => {
//         const flatData = data.map((item) => ({
//             Vendor: item.vendor_name,
//             "Invoice No": item.invoice_no,
//             "Invoice Date": item.invoice_date,
//             "Due Date": item.due_date,
//             "Total Amount ": item.amount,
//             "Paid Amount ": item.paid,
//             "Outstanding ": item.outstanding,
//             "Aging Bucket": item.aging_bucket,
//             Status: item.status,
//         }));

//         const worksheet = XLSX.utils.json_to_sheet(flatData);
//         const workbook = XLSX.utils.book_new();
//         XLSX.utils.book_append_sheet(workbook, worksheet, "Payables Aging");

//         const excelBuffer = XLSX.write(workbook, {
//             bookType: "xlsx",
//             type: "array",
//         });

//         const dataBlob = new Blob([excelBuffer], { type: "application/octet-stream" });
//         saveAs(dataBlob, `Payables_Aging_Report_${moment().format("YYYYMMDD")}.xlsx`);
//     };

//     const formatCurrency = (amount) => {
//         return new Intl.NumberFormat('en-AE', {
//             style: 'currency',
//             currency: 'AED',
//             minimumFractionDigits: 2
//         }).format(amount);
//     };

//     return (
//         <div className="main-content">
//             <div className="page-content">
//                 <div className="container-fluid">
//                     <div className="row">
//                         <div className="col-12">
//                             <div className="page-title-box d-flex align-items-center justify-content-between">
//                                 <h4 className="mb-0 font-size-18">Accounts Payable Aging Report</h4>
//                                 <div className="page-title-right">
//                                     <ol className="breadcrumb m-0">
//                                         <li className="breadcrumb-item"><a href="#">Finance</a></li>
//                                         <li className="breadcrumb-item active">Payables Aging</li>
//                                     </ol>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>

//                     <div className="row">
//                         <div className="col-12">
//                             <div className="card">
//                                 <div className="card-body">
//                                     <div className="row mb-3">
//                                         <div className="col-md-6">
//                                             {/* <h4 className="card-title">Vendor Payables Summary</h4> */}
//                                             {/* <p className="card-title-desc">Outstanding invoices grouped by aging period</p> */}
//                                         </div>
//                                         <div className="col-md-6">
//                                             <div className="d-flex justify-content-end gap-2">
//                                                 {/* <select 
//                                                     className="form-select form-select-sm w-auto"
//                                                     value={dateRange}
//                                                     onChange={(e) => setDateRange(e.target.value)}
//                                                 >
//                                                     <option value="this_month">This Month</option>
//                                                     <option value="last_month">Last Month</option>
//                                                     <option value="this_quarter">This Quarter</option>
//                                                     <option value="custom">Custom Range</option>
//                                                 </select> */}
//                                                 <select
//                                                     className="form-select form-select-sm w-auto"
//                                                     value={selectedVendor}
//                                                     onChange={(e) => setSelectedVendor(e.target.value)}
//                                                 >
//                                                     <option value="">All Vendors</option>
//                                                     {vendors.map((vendor) => (
//                                                         <option key={vendor.id} value={vendor.id}>
//                                                             {vendor.name}
//                                                         </option>
//                                                     ))}
//                                                 </select>
//                                                 <button
//                                                     onClick={exportToExcel}
//                                                     className="btn btn-success btn-sm"
//                                                 >
//                                                     <i className="mdi mdi-file-excel-outline me-1"></i> Export
//                                                 </button>
//                                             </div>
//                                         </div>
//                                     </div>

//                                     {loading ? (
//                                         <div className="text-center py-4">
//                                             <div className="spinner-border text-primary" role="status">
//                                                 <span className="sr-only">Loading...</span>
//                                             </div>
//                                         </div>
//                                     ) : (
//                                         <>
//                                             <div className="row mb-4">
//                                                 <div className="col-md-3">
//                                                     <div className="card border-primary mb-0">
//                                                         <div className="card-body">
//                                                             <h5 className="card-title text-primary">Total Outstanding</h5>
//                                                             <h2 className="mb-0">{(summaryData.totalOutstanding)}</h2>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                                 <div className="col-md-9">
//                                                     <div className="card">
//                                                         <div className="card-body">
//                                                             <h5 className="card-title">Aging Summary</h5>
//                                                             <div className="d-flex justify-content-between text-center">
//                                                                 <div>
//                                                                     <p className="text-muted mb-1">0-30 Days</p>
//                                                                     <h4 className="text-info">{(summaryData.agingBuckets['0-30'])}</h4>
//                                                                 </div>
//                                                                 <div>
//                                                                     <p className="text-muted mb-1">31-60 Days</p>
//                                                                     <h4 className="text-warning">{(summaryData.agingBuckets['31-60'])}</h4>
//                                                                 </div>
//                                                                 <div>
//                                                                     <p className="text-muted mb-1">61-90 Days</p>
//                                                                     <h4 className="text-orange">{(summaryData.agingBuckets['61-90'])}</h4>
//                                                                 </div>
//                                                                 <div>
//                                                                     <p className="text-muted mb-1">Over 90 Days</p>
//                                                                     <h4 className="text-danger">{(summaryData.agingBuckets['90+'])}</h4>
//                                                                 </div>
//                                                             </div>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </div>

//                                             {Object.keys(groupedData).length === 0 ? (
//                                                 <div className="alert alert-info">
//                                                     No outstanding vendor payables found for the selected criteria.
//                                                 </div>
//                                             ) : (
//                                                 <div className="table-responsive">
//                                                     <table className="table table-hover table-centered table-nowrap mb-0">
//                                                         <thead className="table-light">
//                                                             <tr>
//                                                                 <th>Vendor</th>
//                                                                 <th>Invoice No</th>
//                                                                 <th>Invoice Date</th>
//                                                                 <th>Due Date</th>
//                                                                 <th className="text-end">Amount </th>
//                                                                 <th className="text-end">Paid </th>
//                                                                 <th className="text-end">Outstanding </th>
//                                                                 <th>Aging</th>
//                                                                 <th>Status</th>
//                                                             </tr>
//                                                         </thead>
//                                                         <tbody>
//                                                             {Object.entries(groupedData).flatMap(([vendor, items]) => (
//                                                                 <>
//                                                                     <tr className="bg-soft-light">
//                                                                         <td colSpan="9" className="fw-bold">{vendor}</td>
//                                                                     </tr>
//                                                                     {items.map((item, index) => (
//                                                                         <tr key={index}>
//                                                                             <td>{item.vendor_name}</td>
//                                                                             <td>
//                                                                                 <a href="#" className="text-body fw-bold">{item.invoice_no}</a>
//                                                                             </td>
//                                                                             <td>{moment(item.invoice_date).format("DD MMM YYYY")}</td>
//                                                                             <td>{moment(item.due_date).format("DD MMM YYYY")}</td>
//                                                                             <td className="text-end">{item.amount}</td>
//                                                                             <td className="text-end">{item.paid}</td>
//                                                                             <td className="text-end fw-bold">{item.outstanding}</td>
//                                                                             <td>
//                                                                                 <span className={`badge ${item.aging_bucket === '0–30 Days' ? 'bg-info' : 
//                                                                                     item.aging_bucket === '31–60 Days' ? 'bg-warning' : 
//                                                                                     item.aging_bucket === '61–90 Days' ? 'bg-orange' : 'bg-danger'}`}>
//                                                                                     {item.aging_bucket}
//                                                                                 </span>
//                                                                             </td>
//                                                                             <td>
//                                                                                 <span className={`badge ${item.status === 'Paid' ? 'bg-success' : 
//                                                                                     item.status === 'Partial' ? 'bg-warning' : 'bg-danger'}`}>
//                                                                                     {item.status}
//                                                                                 </span>
//                                                                             </td>
//                                                                         </tr>
//                                                                     ))}
//                                                                 </>
//                                                             ))}
//                                                         </tbody>
//                                                     </table>
//                                                 </div>
//                                             )}
//                                         </>
//                                     )}
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

const PayableAgingReport = () => {
    const [data, setData] = useState([]);
    const [groupedData, setGroupedData] = useState({});
    const [vendors, setVendors] = useState([]);
    const [selectedVendor, setSelectedVendor] = useState('');
    const [dateRange, setDateRange] = useState('this_month');
    const [summaryData, setSummaryData] = useState({
        totalOutstanding: 0,
        agingBuckets: {
            '0-30': 0,
            '31-60': 0,
            '61-90': 0,
            '90+': 0
        }
    });

    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    const userInfo = JSON.parse(localStorage.getItem("user-info"));
    const origin = localStorage.getItem("user-origin");
    const token = userInfo?.token;

    useEffect(() => {
        fetchData();
    }, [selectedVendor, dateRange]);

    const fetchData = async () => {
        try {
            const params = selectedVendor ? { vendor_id: selectedVendor } : {};
            const response = await axios.get(`${backendUrl}/api/payable`, {
                params,
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Tenant-Origin": origin,
                },
            });

            const reportData = response.data.data || [];
            const vendorList = response.data.vendors || {};

            setData(reportData);
            setVendors(Object.entries(vendorList).map(([id, name]) => ({ id, name })));
            groupByVendor(reportData);
            calculateSummary(reportData);
        } catch (error) {
            console.error("Error loading payable aging report:", error);
        }
    };

    const calculateSummary = (items) => {
        let total = 0;
        const buckets = {
            '0-30': 0,
            '31-60': 0,
            '61-90': 0,
            '90+': 0
        };

        items.forEach(item => {
            const amount = parseFloat(item.outstanding.replace(/,/g, ''));
            total += amount;

            if (item.aging_bucket === '0–30 Days') buckets['0-30'] += amount;
            else if (item.aging_bucket === '31–60 Days') buckets['31-60'] += amount;
            else if (item.aging_bucket === '61–90 Days') buckets['61-90'] += amount;
            else buckets['90+'] += amount;
        });

        setSummaryData({
            totalOutstanding: total,
            agingBuckets: buckets
        });
    };

    const groupByVendor = (items) => {
        const grouped = {};
        items.forEach((item) => {
            if (!grouped[item.vendor_name]) grouped[item.vendor_name] = [];
            grouped[item.vendor_name].push(item);
        });
        setGroupedData(grouped);
    };

    const exportToExcel = () => {
        const flatData = data.map((item) => ({
            Vendor: item.vendor_name,
            "Invoice No": item.invoice_no,
            "Invoice Date": item.invoice_date,
            "Due Date": item.due_date,
            "Total Amount": item.amount,
            "Paid Amount": item.paid,
            "Outstanding": item.outstanding,
            "Aging Bucket": item.aging_bucket,
            Status: item.status,
        }));

        const worksheet = XLSX.utils.json_to_sheet(flatData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Payables Aging");

        const excelBuffer = XLSX.write(workbook, {
            bookType: "xlsx",
            type: "array",
        });

        const dataBlob = new Blob([excelBuffer], { type: "application/octet-stream" });
        saveAs(dataBlob, `Payables_Aging_Report_${moment().format("YYYYMMDD")}.xlsx`);
    };

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-AE', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(amount);
    };

    return (
        <div className="main-content">
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="page-title-box d-flex align-items-center justify-content-between">
                                <div>
                                    <h4 className="mb-0 font-size-18">Accounts Payable Aging Report</h4>
                                    <ol className="breadcrumb m-0 mt-2">
                                        <li className="breadcrumb-item">Finance</li>
                                        <li className="breadcrumb-item active">Payables Aging</li>
                                    </ol>
                                </div>
                                <div className="d-flex gap-2">
                                    <button
                                        onClick={exportToExcel}
                                        className="btn btn-outline-secondary btn-sm"
                                        disabled={data.length === 0}
                                    >
                                        <i className="mdi mdi-file-excel-outline me-1"></i> Export
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="row mb-4">
                                        <div className="col-md-6">
                                            <div className="d-flex align-items-center gap-3">
                                                <select
                                                    className="form-select form-select-sm w-auto"
                                                    value={selectedVendor}
                                                    onChange={(e) => setSelectedVendor(e.target.value)}
                                                >
                                                    <option value="">All Vendors</option>
                                                    {vendors.map((vendor) => (
                                                        <option key={vendor.id} value={vendor.id}>
                                                            {vendor.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Summary Cards */}
                                    <div className="row mb-4">
                                        <div className="col-md-3">
                                            <div className="card border-start border-start-3 border-start-primary">
                                                <div className="card-body">
                                                    <h6 className="text-muted mb-2">Total Outstanding</h6>
                                                    <h4 className="mb-0">
                                                        {formatCurrency(summaryData.totalOutstanding)}
                                                    </h4>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-9">
                                            <div className="card">
                                                <div className="card-body">
                                                    <h6 className="text-muted mb-3">Aging Summary</h6>
                                                    <div className="row">
                                                        <div className="col-md-3 col-6">
                                                            <div className="border-start border-start-3 border-start-info ps-3">
                                                                <p className="text-muted mb-1">0-30 Days</p>
                                                                <h4 className="text-info">
                                                                    {formatCurrency(summaryData.agingBuckets['0-30'])}
                                                                </h4>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3 col-6">
                                                            <div className="border-start border-start-3 border-start-warning ps-3">
                                                                <p className="text-muted mb-1">31-60 Days</p>
                                                                <h4 className="text-warning">
                                                                    {formatCurrency(summaryData.agingBuckets['31-60'])}
                                                                </h4>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3 col-6">
                                                            <div className="border-start border-start-3 border-start-orange ps-3">
                                                                <p className="text-muted mb-1">61-90 Days</p>
                                                                <h4 className="text-orange">
                                                                    {formatCurrency(summaryData.agingBuckets['61-90'])}
                                                                </h4>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3 col-6">
                                                            <div className="border-start border-start-3 border-start-danger ps-3">
                                                                <p className="text-muted mb-1">Over 90 Days</p>
                                                                <h4 className="text-danger">
                                                                    {formatCurrency(summaryData.agingBuckets['90+'])}
                                                                </h4>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Data Table */}
                                    {Object.keys(groupedData).length === 0 ? (
                                        <div className="alert alert-info">
                                            No outstanding vendor payables found for the selected criteria.
                                        </div>
                                    ) : (
                                        <div className="table-responsive">
                                            <table className="table table-hover align-middle">
                                                <thead className="table-light">
                                                    <tr>
                                                        <th>Vendor</th>
                                                        <th>Invoice #</th>
                                                        <th>Date</th>
                                                        <th>Due Date</th>
                                                        <th className="text-end">Amount</th>
                                                        <th className="text-end">Paid</th>
                                                        <th className="text-end">Outstanding</th>
                                                        <th>Aging</th>
                                                        <th>Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {Object.entries(groupedData).flatMap(([vendor, items]) => (
                                                        <React.Fragment key={vendor}>
                                                            <tr className="table-group-divider">
                                                                <td colSpan="9" className="bg-light">
                                                                    <div className="d-flex justify-content-between align-items-center">
                                                                        <strong>{vendor}</strong>
                                                                        <span className="badge bg-light text-dark">
                                                                            Total: {formatCurrency(items.reduce((sum, item) => sum + parseFloat(item.outstanding.replace(/,/g, '')), 0))}
                                                                        </span>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                            {items.map((item, index) => (
                                                                <tr key={index}>
                                                                    <td>{item.vendor_name}</td>
                                                                    <td>
                                                                        <span className="fw-medium">{item.invoice_no}</span>
                                                                    </td>
                                                                    <td>{moment(item.invoice_date).format("DD MMM YYYY")}</td>
                                                                    <td>{moment(item.due_date).format("DD MMM YYYY")}</td>
                                                                    <td className="text-end">{formatCurrency(parseFloat(item.amount.replace(/,/g, '')))}</td>
                                                                    <td className="text-end">{formatCurrency(parseFloat(item.paid.replace(/,/g, '')))}</td>
                                                                    <td className="text-end fw-bold">{formatCurrency(parseFloat(item.outstanding.replace(/,/g, '')))}</td>
                                                                    <td>
                                                                        <span className={`badge ${item.aging_bucket === '0–30 Days' ? 'bg-info' : 
                                                                            item.aging_bucket === '31–60 Days' ? 'bg-warning' : 
                                                                            item.aging_bucket === '61–90 Days' ? 'bg-orange' : 'bg-danger'}`}>
                                                                            {item.aging_bucket}
                                                                        </span>
                                                                    </td>
                                                                    <td>
                                                                        <span className={`badge ${item.status === 'Paid' ? 'bg-success' : 
                                                                            item.status === 'Partial' ? 'bg-warning' : 'bg-danger'}`}>
                                                                            {item.status}
                                                                        </span>
                                                                    </td>
                                                                </tr>
                                                            ))}
                                                        </React.Fragment>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PayableAgingReport;
